import React from "react";
import { useSelector } from "react-redux";
import { selectAllP2pSettings } from "../../../../redux/slices/p2pSettingsSlice";
import { selectAllRegistration } from "../../../../redux/slices/registrationSlice";
import { selectAllCategories } from "../../../../redux/slices/categoriesSlice";
import CreateTeamNav from "./CreateTeamNav";

const ConnectedCreateTeamNav = () => {
    const { enableTeamJoin } = useSelector(selectAllP2pSettings);
    const {
        currentRegistrationCategory = [],
        registrations = [],
        currentRegistration = 0,
    } = useSelector(selectAllRegistration);
    const categories = useSelector(selectAllCategories);
    const currentCategoryId =
        currentRegistrationCategory.length > 0
            ? Number(currentRegistrationCategory[0])
            : Number(registrations[currentRegistration].Category[0]);

    const currentCategoryCanJoinTeam =
        currentRegistrationCategory &&
        categories.find((category) => category.id === currentCategoryId)
            ?.attachTeamMembers;
    const isVisible = enableTeamJoin && currentCategoryCanJoinTeam;

    return <CreateTeamNav isVisible={isVisible} />;
};

export default ConnectedCreateTeamNav;
